module.exports = __webpack_public_path__ + "img/null_img.7e871f4d.svg";